import type { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen text-[#2C2C2C] antialiased">
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
